export default{
	encodeData(value){
		if (!value){
			return null;
		}
		
		var encoded = JSON.stringify(value);
		encoded = encoded.trim();
		encoded = encodeURI(encoded);
		return encoded;
	},
	decodeData(encoded, def){
		var value = null;
		try {
			value = decodeURI(encoded);
			
			while (value[value.length - 1] == ",") {
				value = value.substr(0, value.length - 1);
			}
	
			value = JSON.parse(value);
		} catch (ex) { 
			console.log(ex);
		}

		if (!value || typeof value == 'undefined' || value == null || value == "" || value == "undefined") {
			return def;
		}

		return value;
	},
	MBPutData(selector, data) {
		var encoded = this.encodeData(data);
		window.$(selector).val(encoded);
	},
	MBGetData(selector) {
		var encoded = window.$(selector).val();
		return this.DecodeData(encoded);
	}
	
}